/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface GetEmailQueueCount200Response
 */
export interface GetEmailQueueCount200Response {
    /**
     * 
     */
    count?: number;
}

/**
 * Check if a given object implements the GetEmailQueueCount200Response interface.
 */
export function instanceOfGetEmailQueueCount200Response(value: object): value is GetEmailQueueCount200Response {
    return true;
}

export function GetEmailQueueCount200ResponseFromJSON(json: any): GetEmailQueueCount200Response {
    return GetEmailQueueCount200ResponseFromJSONTyped(json, false);
}

export function GetEmailQueueCount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailQueueCount200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function GetEmailQueueCount200ResponseToJSON(json: any): GetEmailQueueCount200Response {
    return GetEmailQueueCount200ResponseToJSONTyped(json, false);
}

export function GetEmailQueueCount200ResponseToJSONTyped(value?: GetEmailQueueCount200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

